import { useState } from "react";
import { motion } from "framer-motion";
import { TiltCard } from "@/components/site/TiltCard";
import { CountUp } from "@/components/site/CountUp";
import { Reveal } from "@/components/site/Reveal";
import { BIG_IDEA_STATS, BIG_IDEA_FOOTNOTE } from "@/data/site";

const StatCard = ({ stat, index }) => {
  const [hover, setHover] = useState(false);
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <TiltCard
        max={5}
        className="h-full"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-cursor-color={stat.color}
      >
        <div
          data-testid={`stat-${index}`}
          className="flex h-full flex-col justify-between border border-hair bg-white p-8 transition-colors duration-300"
          style={{ backgroundColor: hover ? `${stat.color}0D` : "#FFFFFF" }}
        >
          <motion.div
            className="font-heading text-5xl font-black leading-none tracking-tight md:text-6xl"
            style={{ color: stat.color }}
            animate={{ x: hover ? 2 : 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <CountUp
              end={stat.value}
              decimals={stat.decimals || 0}
              suffix={stat.suffix}
            />
          </motion.div>
          <p className="mt-6 text-base leading-relaxed text-ink">{stat.desc}</p>
          <p
            className="mt-6 text-xs uppercase tracking-[0.14em] text-graphite"
            style={{ textDecoration: hover ? "underline" : "none" }}
          >
            {stat.source}
          </p>
        </div>
      </TiltCard>
    </Reveal>
  );
};

export const BigIdea = () => {
  return (
    <section id="big-idea" data-testid="section-big-idea" className="border-t border-hair py-12 md:py-20">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <span className="eyebrow">Dlaczego teraz</span>
          <h2 className="mt-4 max-w-4xl font-heading text-4xl font-bold leading-[1.02] tracking-tight text-ink md:text-6xl">
            Ekrany rosną. Wyobraźnia maleje.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {BIG_IDEA_STATS.map((s, i) => (
            <StatCard key={i} stat={s} index={i} />
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 max-w-4xl text-xs leading-relaxed text-graphite">{BIG_IDEA_FOOTNOTE}</p>
        </Reveal>
      </div>
    </section>
  );
};
